import article1 from "./article1_apa-itu-new-normal";
import article2 from "./article2_new-normal-di-tempat-ibadah";
import article3 from "./article3_informasi-kredibel";

const articles = [article3, article2, article1];

export default articles;
